import type {
  CreateWebhookResponse,
  WebhooksResponse,
} from "@server/types/responseTypes";
import type { WebhookEventType } from "@server/types/webhookEventTypes.ts";
import { apiDelete, apiGet, apiPost, createOrgApiUrl } from "@/utils/apiUtils";

export const fetchWebhooks = async (organizationId: string) => {
  const res = await apiGet<WebhooksResponse>(
    createOrgApiUrl(organizationId, "webhooks"),
  );
  return res.data;
};

export const createWebhook = async ({
  organizationId,
  name,
  url,
  event_types,
}: {
  organizationId: string;
  name: string;
  url: string;
  event_types: WebhookEventType[];
}) => {
  const res = await apiPost<CreateWebhookResponse>(
    createOrgApiUrl(organizationId, "webhooks"),
    { name, url, event_types },
  );
  return res.data;
};

export const deleteWebhook = async ({
  organizationId,
  webhookId,
}: {
  organizationId: string;
  webhookId: string;
}) => {
  await apiDelete(createOrgApiUrl(organizationId, `webhooks/${webhookId}`));
};
